import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index' // 首页
import Meeting from '@/components/meeting' // 会议
import Salon from '@/components/salon' // 沙龙
import Activity from '@/components/activity' // 活动
import infoPage from '@/components/info/info' // 详情页
import slinfo from '@/components/info/slinfo' // 沙龙详情页

import listPage from '@/components/info/list' // 列表页
import listinfoPage from '@/components/info/listInfo' // 列表详情页
import newinfoPage from '@/components/info/newinfo' // 资讯详情页
import peopleList from '@/components/info/peoplelist' // 嘉宾列表页
import peopleInfo from '@/components/info/peopleinfo' // 嘉宾详情页
import searchPage from '@/components/search/search' // 活动搜索页
import enrollPage1 from '@/components/order/enroll-01' // 报名页1
import enrollPage2 from '@/components/order/enroll-02' // 填写报名信息
import orderPerfect from '@/components/order/order_perfect' //完善参会人信息
import orderPerfect2 from '@/components/order/order_perfect2' //完善住宿信息
import Sign_s from '@/components/order/sign_success' //报名成功
import huikuan from '@/components/order/huikuan' //报名成功汇款信息页
import OrderDetails from '@/components/order/order_details' //报名详情
import Ticket from '@/components/order/ticket_situation' //报名详情>门票是否使用
import Meetpeoples from '@/components/order/meet_peoples' //确认订单

import myEnroll from '@/components/order/myEnroll' //我的活动
import myOrder from '@/components/order/myOrder' //我的订单
import myInvoice from '@/components/order/myInvoice' //我的发票
import orderInfo from '@/components/order/order_info' //查看我的会议信息
import addInvoice from '@/components/order/addInvoice' //开发票页
import invoiceList from '@/components/order/invoiceList' //发票管理
import invoiceInfo from '@/components/order/invoiceInfo' //发票详情
import invoiceNum from '@/components/order/invoiceNum' //发票数量

import seatList from '@/components/order/seat/seatList' //查询我的座位列表页
  import seatShareList from '@/components/order/seat/seatShareList' //无订单查询我的座位列表页
import mySeat from '@/components/order/seat/mySeat' //我的座位页

 import power from '@/components/info/power' //没有权限

import Future from '@/components/meet/future'  //近期全部会议


//  会议2期修改
  import Index2 from '@/components/Index2' // 首页2.0
  import Search2 from '@/components/search/search2' // 搜索2.0

    import timeInfo from '@/components/info/timeInfo' //图文直播详情

import shares from './routes/shares'
import test from './routes/test'
  import template from './routes/template'

Vue.use(Router);
const routes = [

  {
    path: '/',
    name: 'Index',
    component: Index,
    meta: {
      title: '先晓会议'
    }
  },
  {
    path: '/meeting',
    name: 'Meeting',
    component: Meeting,
    meta: {
      title: '会议'
    }
  },
  {
    path: '/salon',
    name: 'Salon',
    component: Salon,
    meta: {
      title: '沙龙'
    }
  },
  {
    path: '/activity',
    name: 'Activity',
    component: Activity,
    meta: {
      title: '活动'
    }
  },
  {
    path: '/info/:id',
    name: 'infoPage',
    props: true,
    component: infoPage,
    meta: {
      title: '活动详情'
    }
  },
  {
    path: '/slinfo/:id',
    name: 'slinfo',
    props: true,
    component: slinfo,
    meta: {
      title: '沙龙详情'
    }
  },
  {
    path: '/list/:id',
    name: 'listPage',
    props: true,
    component: listPage,
    meta: {
      title: '列表'
    }
  },
  {
    path: '/listinfo/:id',
    name: 'listinfoPage',
    props: true,
    component: listinfoPage,
    meta: {
      title: '列表单页'
    }
  },
  {
    path: '/newinfo/:id',
    name: 'newinfoPage',
    props: true,
    component: newinfoPage,
    meta: {
      title: '资讯详情'
    }
  },
  {
    path: '/future',
    name: 'future',
    props: true,
    component: Future,
    meta: {
      title: '近期会议'
    }
  },
  {
    path: '/search/:text',
    name: 'searchPage',
    props: true,
    component: searchPage,
    meta: {
      title: '活动搜索'
    }
  },
  {
    path: '/peoplelist/:id',
    name: 'peopleList',
    props: true,
    component: peopleList,
    meta: {
      title: '嘉宾列表'
    }
  },
  {
    path: '/peopleinfo/:id',
    name: 'peopleInfo',
    props: true,
    component: peopleInfo,
    meta: {
      title: '嘉宾详情'
    }
  },
  {
    path: '/enroll01/:id',
    name: 'enrollPage1',
    props: true,
    component: enrollPage1,
    meta: {
      title: '选择报名会议'
    }
  },
  {
    path: '/enroll02/:id',
    name: 'enrollPage2',
    props: true,
    component: enrollPage2,
    meta: {
      title: '填写报名信息'
    }
  },
  {
    path: '/signsuccess/:order_no',
    name: 'Sign_s',
    props: true,
    component: Sign_s,
    meta: {
      title: '报名成功'
    }
  },
  {
    path: '/huikuan/:order_no',
    name: 'huikuan',
    props: true,
    component: huikuan,
    meta: {
      title: '报名成功'
    }
  },
  {
    path: '/orderDetails/:order_no',
    name: 'OrderDetails',
    props: true,
    component: OrderDetails,
    meta: {
      title: '订单详情'
    }
  },
  {
    path: '/orderInfo/:order_no',
    name: 'orderInfo',
    props: true,
    component: orderInfo,
    meta: {
      title: '我的会议信息'
    }
  },
  {
    path: '/ticket/:id',
    name: 'Ticket',
    props: true,
    component: Ticket,
    meta: {
      title: '订单详情门票使用情况'
    },
  },
  {
    path: '/orderperfect/:id',
    name: 'orderPerfect',
    props: true,
    component: orderPerfect,
    meta: {
      title: '完善报名信息'
    }
  },
  {
    path: '/orderperfect2/:id',
    name: 'orderPerfect2',
    props: true,
    component: orderPerfect2,
    meta: {
      title: '完善住宿信息'
    }
  },
  {
    path: '/Meetpeoples/:order_no',
    name: 'Meetpeoples',
    props: true,
    component: Meetpeoples,
    meta: {
      title: '确认订单'
    }
  },
  {
    path: '/myEnroll',
    name: 'myEnroll',
    component: myEnroll,
    meta: {
      title: '我的报名'
    }
  },
  {
    path: '/myOrder',
    name: 'myOrder',
    component: myOrder,
    meta: {
      title: '我的订单'
    }
  },
  {
    path: '/myInvoice',
    name: 'myInvoice',
    component: myInvoice,
    meta: {
      title: '我的发票'
    }
  },
  {
    path: '/addInvoice',
    name: 'addInvoice',
    component: addInvoice,
    meta: {
      title: '开发票'
    }
  },
  {
    path: '/invoiceNum',
    name: 'invoiceNum',
    component: invoiceNum,
    meta: {
      title: '开发票'
    }
  },
  {
    path: '/invoiceList',
    name: 'invoiceList',
    component: invoiceList,
    meta: {
      title: '发票管理'
    }
  },
  {
    path: '/invoiceInfo/:id',
    props: true,
    name: 'invoiceInfo',
    component: invoiceInfo,
    meta: {
      title: '发票详情'
    }
  },
  {
    path: '/power',
    name: 'power',
    component: power,
    meta: {
      title: '会议权限'
    }
  },
  {
    path: '/seatList/:order_no',
    name: 'seatList',
    props: true,
    component: seatList,
    meta: {
      title: '查询我的座位'
    }
  },
  {
    path: '/seatShareList/:id',
    name: 'seatShareList',
    props: true,
    component: seatShareList,
    meta: {
      title: '查询我的座位'
    }
  },
  {
    path: '/mySeat/:id/:q/:h/:l',
    name: 'mySeat',
    props: true,
    component: mySeat,
    meta: {
      title: '我的座位'
    }
  },
]
const routes2 = [
  {
    path: '/Index2',
    name: 'Index2',
    component: Index2,
    meta: {
      title: '先晓会议'
    }
  },
  {
    path: '/Search2',
    name: 'Search2',
    props:true,
    component: Search2,
    meta: {
      title: '活动搜索'
    }
  },
  {
    path: '/timeInfo/:id',
    name: 'timeInfo',
    props:true,
    component: timeInfo,
    meta: {
      title: '图文直播'
    }
  },
]

import addOrder01 from '@/components/admin/addOrder_01' //后台添加订单
  import addOrder02 from '@/components/admin/addOrder_02' //后台添加订单

const admin = [
  {
    path: '/addOrder01/:id',
    name: 'addOrder01',
    component: addOrder01,
    props: true,
    meta: {
      title: '先晓会议'
    }
  },
  {
    path: '/addOrder02/:id',
    name: 'addOrder02',
    props: true,
    component: addOrder02,
    meta: {
      title: '先晓会议'
    }
  },
]
const router = new Router({
  routes:[
    ...routes,
    ...routes2,
    ...admin,
    ...shares,
    ...test,
    ...template
  ],
  mode: 'hash',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
